<template>
    <v-combobox
        ref="initialDiagnosis"
        v-model="initialDiagnosis"
        :rules="rules.diagnosis"
        :items="computedItems"
        return-object
        color="#009688"
        clearable
        :search-input.sync="searchInputSync"
        label="Initial Diagnosis"
        auto-grow
        rows="1"
        item-text="DIAG_DISPLAY"
        autocomplete="nope"
        row-height="15"
        @update:search-input="handleSearchInput"
        @blur="handleBlurInitialDiagnosis"
    >
        <template #selection="{ item }">
            <v-chip v-if="item.ICD_C" color="teal" style="color: white">
                {{ item.ICD_C }}
            </v-chip> {{ item.DIAGNOSIS }}
        </template>
        <template #item="{ item }">
            <v-list class="custom-menu">
                <v-list-item style="width: 100%;">
                    <v-list-item-content>
                        <v-list-item-title style="text-wrap: wrap;">
                            <v-chip v-if="item.ICD_C" color="teal" style="color: white">
                                {{ item.ICD_C }}
                            </v-chip> {{ item.DIAGNOSIS }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </template>
        <template #no-data>
            <p v-if="searchInputSync" class="errSearchDoctor">
                Use <strong>"{{ searchInputSync }}"</strong>?
                <v-chip
                    color="teal accent-4"
                    text-color="white"
                    @click.stop="saveInitialDiagnosis"
                >
                    Continue
                </v-chip>
            </p>
        </template>
    </v-combobox>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data: () => ({
        searchInputSync: null,
        items: [],
        rules: {
            diagnosis: [
                v => !!v || 'This field is required',
                v => v && /[a-zA-Z]/.test(v.DIAG_DISPLAY) || 'Please provide a valid diagnosis!'
            ]
        },
        initialDiagnosis: null
    }),
    computed: {
        ...mapGetters(['getDiagnosisListData']),
        computedItems() {
            // Always create a custom item at index 0 if searchInputSync exists
            const baseItems = this.items.map(item => ({
                DIAG_DISPLAY: `${item.ICD_C} ${item.DIAGNOSIS}`,
                ...item
            }))

            // If there's a search input, add a custom item at the beginning
            if (this.searchInputSync) {
                const customItem = {
                    DIAGNOSIS: this.searchInputSync.toUpperCase(),
                    DIAG_DISPLAY: this.searchInputSync.toUpperCase(),
                    ICD_C: null
                }
                return [customItem, ...baseItems]
            }
            return baseItems
        }
    },
    watch: {
        initialDiagnosis: {
            handler(newVal) {
                this.$emit('saveInitialDiagnosis', newVal)
            }
        },
        getDiagnosisListData(newVal) {
            if (newVal && newVal.data) {
                this.items = newVal.data.map(item => ({
                    DIAG_DISPLAY: `${item.ICD_C} ${item.DIAGNOSIS}`,
                    ...item
                }))
            }
        }
    },
    methods: {
        handleBlurInitialDiagnosis() {
            if (this.initialDiagnosis === null || typeof this.initialDiagnosis === 'string') {
                this.initialDiagnosis = {
                    'DIAG_DISPLAY': this.searchInputSync.toUpperCase(),
                    'ICD_C': null,
                    'DIAGNOSIS': this.searchInputSync.toUpperCase()
                }
            }
        },
        handleSearchInput() {
            this.$nextTick(() => {
                // Locate the dropdown content inside the menu
                const dropdown = document.querySelector('.v-menu__content')

                if (dropdown) {
                    this.$nextTick(() => {
                        dropdown.scrollTop = 0 // Scrolls only the dropdown, not the whole page
                    })
                }
            })
        },
        blurInitialDiagnosis() {
            this.$refs.initialDiagnosis.blur()
        },
        saveInitialDiagnosis() {
            // Create a new diagnosis object when user wants to continue with custom input
            if (this.searchInputSync) {
                const customDiagnosis = {
                    DIAGNOSIS: this.searchInputSync.toUpperCase(),
                    DIAG_DISPLAY: this.searchInputSync.toUpperCase(),
                    ICD_C: null
                }
                this.initialDiagnosis = customDiagnosis
            }
        }
    }
}
</script>

<style scoped>
.custom-menu {
    padding: 0 10px;
    margin: 0 10px 0 -13px;
    height: auto;
    width: 100%;
}
.errSearchDoctor {
    padding: 5px 5px 0 5px;
    margin: 0;
}
</style>
